import type { DashboardState, UsageRow } from '../../api';
import { StatusDot, costTitle, money } from '../../components/kit';

export function ScopeStrip({ state }: { state: DashboardState }) {
  const usage = state.usage as UsageRow[];
  const total = (mode: 'api' | 'plan') =>
    usage
      .filter((row) => (mode === 'api' ? row.billing === 'api' : row.billing !== 'api'))
      .reduce((sum, row) => sum + row.costUsd, 0);
  const metered = total('api');
  const tokens = usage.reduce((sum, row) => sum + row.tokens, 0);
  const runs = usage.reduce((sum, row) => sum + row.runs, 0);

  return (
    <div className="mb-5 flex flex-wrap items-center gap-x-5 gap-y-2 rounded-[7px] border border-rule bg-panel px-4 py-2.5 shadow-[var(--shadow-panel)]">
      <Reading
        label="Running"
        value={String(state.running.length)}
        state={state.running.length > 0 ? 'running' : undefined}
      />
      <Reading
        label="Queued"
        value={String(state.queue.length)}
        state={state.queue.length > 0 ? 'queued' : undefined}
      />
      <span className="hidden h-6 w-px bg-rule sm:block" aria-hidden />
      <Reading label="Runs 24h" value={String(runs)} />
      <Reading
        label="Tokens 24h"
        value={tokens > 0 ? `${Math.round(tokens / 1000).toLocaleString('en-US')}k` : '0'}
      />
      {/* Only money somebody was actually charged. An installation on a
          subscription is charged nothing per run, and a headline figure for what
          it "would have cost" is a number to worry about that nobody owes — the
          equivalence stays under Usage, where a reader has gone looking for it. */}
      {metered > 0 && <Reading label="Spend 24h" value={money(metered)} title={costTitle('api')} />}
    </div>
  );
}

function Reading({
  label,
  value,
  title,
  state,
}: {
  label: string;
  value: string;
  title?: string;
  state?: 'running' | 'queued';
}) {
  return (
    <div className="flex items-baseline gap-2" title={title}>
      <span className="label-caps">{label}</span>
      <span className="flex items-center gap-1.5 text-[15px] font-semibold tracking-[-0.01em] tabular-nums">
        {state && <StatusDot state={state} />}
        {value}
      </span>
    </div>
  );
}
